import classNames from "classnames";

export function cn(...args: classNames.ArgumentArray) {
  return classNames(args);
}

export const formatCurrency = (value: number) => {
  return (
    "S" +
    new Intl.NumberFormat("en-SG", {
      style: "currency",
      currency: "SGD",
      maximumFractionDigits: 0,
    }).format(value)
  );
};

export const formatNumber = (num: string) => {
  const cleanNum = num.replace(/\D/g, "");
  return Number(cleanNum).toLocaleString("en-US");
};

export function mapQuestionsById<T extends { questionId: string }>(
  questions: T[],
) {
  return questions.reduce(
    (acc, question) => {
      acc[question.questionId] = question;
      return acc;
    },
    {} as Record<string, T>,
  );
}

export function generateUuid(): string {
  const uuidTemplate: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return uuidTemplate.replace(/[xy]/g, (c: string) => {
    const r: number = (Math.random() * 16) | 0;
    const v: number = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
